import * as React from "react";
import { ActionHandlerFunction, ActivityLogInfo } from "@preveil-api";
import { GlobalConstants, SettingsUIActionTypes } from "src/common";
import { SimplePagination, ToolbarWrapper } from "src/components";

type AllProps = {
  handleAction: ActionHandlerFunction;
  activity_logs: ActivityLogInfo[];
  is_loading: boolean;
  page: number;
};

/* Description: Toolbar for activity logs, contains a simple pagination and refresh. */
function LogsToolBarComponent(props: AllProps) {
  const { handleAction, activity_logs, is_loading, page } = props;

  return (
    <ToolbarWrapper
      pagination={<SimplePagination
        isFirst={page === 0}
        isLast={activity_logs.length < GlobalConstants.ACTIVITY_PER_PAGE_COUNT} // TO DO: need to ask the backend if they can add a "total_rows" field in the user logs call (BACK-899)
        className="mb-0 justify-content-end"
        handleAction={handleAction}
      />}
      refreshAction={() => handleAction({ actionType: SettingsUIActionTypes.Refresh })}
      refreshTooltipContent="Refresh Activity Logs"
      isLoading={is_loading}
      paginationInfo={<span>
        {activity_logs.length === 0 ? <b>0 Items</b> :
          <>
            <b>{page * GlobalConstants.ACTIVITY_PER_PAGE_COUNT + 1}</b> -{" "}
            <b>
              {activity_logs.length < GlobalConstants.ACTIVITY_PER_PAGE_COUNT
                ? page * GlobalConstants.ACTIVITY_PER_PAGE_COUNT + activity_logs.length
                : (page + 1) * GlobalConstants.ACTIVITY_PER_PAGE_COUNT}
            </b>
          </>}
      </span>}
    />
  );
}

export default React.memo(LogsToolBarComponent);
